import {Select} from '@wandb/weave/components/Form/Select';
import {Icon} from '@wandb/weave/components/Icon';
import {RemovableAlias, RemoveAction} from '@wandb/weave/components/Tag';
import React from 'react';
import {
  components,
  type ControlProps,
  type MultiValueProps,
} from 'react-select';

import {TRUNCATED_LABEL_MAX_CHARS, UNLABELED} from './constants';

type LogLabelFilterProps = {
  allLabels: LogLabelFilterOption[];
  selectedLabels: readonly LogLabelFilterOption[];
  onChange: (labels: readonly LogLabelFilterOption[]) => void;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
};

export type LogLabelFilterOption = {
  value?: string | null;
  displayText: string;
};

export const labelToOption = (label?: string | null): LogLabelFilterOption => ({
  value: label,
  displayText: label || UNLABELED,
});

export const LogLabelFilter = ({
  allLabels,
  selectedLabels,
  onChange,
  onMenuOpen,
  onMenuClose,
}: LogLabelFilterProps) => {
  return (
    <Select<LogLabelFilterOption, true>
      aria-label="Filter logs by label"
      size="variable"
      value={selectedLabels}
      options={allLabels}
      placeholder="Filter by label"
      isMulti
      isSearchable
      closeMenuOnSelect={false}
      onChange={opt => onChange(opt)}
      getOptionLabel={opt => opt.displayText}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      components={{
        Control: LogLabelFilterControl,
        MultiValue: LogLabelFilterMultiValue,
      }}
    />
  );
};

const LogLabelFilterControl = ({
  children,
  ...props
}: ControlProps<LogLabelFilterOption, true>) => {
  return (
    <components.Control className="pl-8" {...props}>
      <Icon
        name="filter-alt"
        className="mt-7 h-18 w-18 self-start text-wb-text-tertiary"
        role="presentation"
      />
      {children}
    </components.Control>
  );
};

const LogLabelFilterMultiValue = (
  props: MultiValueProps<LogLabelFilterOption, true>
) => {
  return (
    <components.MultiValue
      {...props}
      components={{
        Container: () => (
          <RemovableAlias
            color="moon"
            label={props.data.displayText}
            maxChars={TRUNCATED_LABEL_MAX_CHARS}
            truncatedPart="middle"
            removeAction={<RemoveAction {...props.removeProps} />}
          />
        ),
        Label: () => null,
        Remove: () => null,
      }}
    />
  );
};
